import { Schema } from 'rsuite'

const { StringType, NumberType, DateType } = Schema.Types

export default Schema.Model({
  from: DateType('Выберите время начала'),
  to: DateType('Выберите время окончания')
})
